import React, { useContext, useEffect, useState } from 'react';
import CardContainer from '../../../../components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from '../../../../components/redesign/KpiGrid';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import KpiTile from 'components/redesign/KpiTile';
import productionPlanning from '../../../../v2/kpis/mct/meslite/cpp';
import downTime from '../../../../v2/kpis/mct/meslite/downtime';
import manuFacturingFillRate from '../../../../v2/kpis/mct/meslite/manufacturingFillRate';
import throughPutLosses from '../../../../v2/kpis/mct/meslite/throughputLosses';
import trueEfficiency from '../../../../v2/kpis/mct/meslite/trueEfficiency';
import wasteKPI from '../../../../v2/kpis/mct/meslite/waste';
import { useDynamicGraphQLQuery } from 'hooks/useDynamicGraphQLQuery';

interface MESLiteValueCreationScoreCardProps {
  title: string;
  showInfoIcon?: boolean;
}
const MESLiteValueCreationScoreCard: React.FC<
  MESLiteValueCreationScoreCardProps
> = ({ title, showInfoIcon = true }) => {
  const { selectedProduct, selectedPlant } = useContext(FilterContext);
  const { data, isLoading } = useDynamicGraphQLQuery(
    'getMesValueCreationScoreCard',
    {
      siteId: selectedPlant?.id ? selectedPlant?.id : null,
    },
    true,
    null,
    'network-only'
  );
  const [overviewConfig, setOverviewConfig] = useState<KpiData[]>([]);

  const generateScoreCardItems = (data: any) => {
    return [
      manuFacturingFillRate.handler(data),
      throughPutLosses.handler(data),
      wasteKPI.handler(data),
      downTime.handler(data),
      trueEfficiency.handler(data),
      productionPlanning.handler(data),
    ];
  };

  useEffect(() => {
    if (data?.getMesValueCreationScoreCard?.data) {
      setOverviewConfig(
        generateScoreCardItems({ ...data?.getMesValueCreationScoreCard?.data })
      );
    }
  }, [data?.getMesValueCreationScoreCard?.data]);

  return (
    <CardContainer
      title={title}
      showInfoIcon={showInfoIcon}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]?.valueCreation
            ?.scoreCard ?? [],
      }}
      isAccordion={false}
      isLoading={isLoading}
    >
      <KpiGrid columnsDesktop={3} columnsTablet={3} columnsMobile={2}>
        {overviewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default MESLiteValueCreationScoreCard;
